import * as yup from 'yup';
import { ISignUpBiddingFormSchemaTranslations } from './SignUpBiddingForm.types';
import { MIN_QUANTITY_REQUIRED_MT } from '@customer-platform-shared//components/Forms/Forms.const';
import { USER_ROLE_TYPE_ENUM } from '@frontend/api';
import { matchIsValidTel } from 'mui-tel-input';

function maxNumbersAfterDecimalValidation(number?: number) {
  if (number === undefined) {
    return true;
  }
  return /^\d+(\.\d{0,5})?$/.test(number.toString());
}

const validatePhoneNumber = (phoneNumber = '') => {
  if (!phoneNumber) return true;
  return matchIsValidTel(phoneNumber);
};

export default function getSignUpBiddingFormSchema({
  required,
  requiredCheckbox,
  maxNumbersAfterDecimal,
  minQuantityRequired,
  emailInvalidMsg,
  phoneNumberInvalidMsg,
}: ISignUpBiddingFormSchemaTranslations) {
  return yup.object().shape({
    price: yup
      .number()
      .positive()
      .test(
        'maxNumbersAfterDecimal',
        maxNumbersAfterDecimal,
        maxNumbersAfterDecimalValidation,
      )
      .required(required)
      .transform((val, orig) => (orig === '' ? undefined : val)),
    quantity: yup
      .number()
      .positive()
      .required(required)
      .min(MIN_QUANTITY_REQUIRED_MT, minQuantityRequired)
      .test(
        'maxNumbersAfterDecimal',
        maxNumbersAfterDecimal,
        maxNumbersAfterDecimalValidation,
      )
      .transform((val, orig) => (orig === '' ? undefined : val)),

    termsAgreed: yup
      .boolean()
      .oneOf([true], requiredCheckbox)
      .required(requiredCheckbox),

    firstName: yup.string().required(required),
    lastName: yup.string().required(required),
    companyName: yup.string().required(required),
    email: yup
      .string()
      .email(emailInvalidMsg)
      .matches(/^[^@]+@[^@]+\.[^@]{2,}$/, emailInvalidMsg)
      .required(required),
    phoneNumber: yup
      .string()
      .test('phoneNumberValidation', phoneNumberInvalidMsg, validatePhoneNumber)
      .required(required),
    role: yup
      .mixed<typeof USER_ROLE_TYPE_ENUM.BUYER>()
      .oneOf([USER_ROLE_TYPE_ENUM.BUYER])
      .default(USER_ROLE_TYPE_ENUM.BUYER),
    whatsappConsent: yup.boolean().optional(),
    listingUuid: yup.string().required(required),
  });
}
